/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { BILLS_TAGS, INVOICES_LIMIT } from 'app-constants'
import { financialService } from 'services'

const CUSTOMER_INVOICES_INITIAL_STATE = {
  isLoading: true,
  content: [],
  hasMore: false,
  page: 0,
}

const CUSTOMER_PAID_BILLS_INITIAL_STATE = {
  isLoading: true,
  content: [],
  hasMore: false,
  page: 0,
}

const INITIAL_STATE = {
  bankSlips: {
    isLoading: true,
    content: [],
    hasPendingNegotiated: false,
    daysToBreachOfAgreement: null,
  },
  invoices: { ...CUSTOMER_INVOICES_INITIAL_STATE },
  paid: { ...CUSTOMER_PAID_BILLS_INITIAL_STATE },
}

const { getBankSlips, getInvoices, getPaidSlips } = financialService()

export const fetchBankSlips = createAsyncThunk('customer/fetchBankSlips', async contractId => {
  const { data } = await getBankSlips(contractId)

  return data
})

export const fetchInvoices = createAsyncThunk(
  'customer/fetchInvoices',
  async (contractId, { getState }) => {
    const { invoices } = getState().financial
    const { page } = invoices

    const { data } = await getInvoices(contractId, page + 1, INVOICES_LIMIT)

    return data
  }
)

export const fetchPaidInvoices = createAsyncThunk(
  'customer/fetchPaidInvoices',
  async (contractId, { getState }) => {
    const { paid } = getState().financial

    const { page } = paid

    const { data } = await getPaidSlips(contractId, page + 1, 10)

    return data
  }
)

export const financialSlice = createSlice({
  name: 'financial',
  initialState: INITIAL_STATE,
  extraReducers: builder => {
    builder
      .addCase(fetchBankSlips.fulfilled, (state, action) => {
        const bankSlips = action.payload
        const negotiated = bankSlips.find(bankSlip =>
          bankSlip.tags?.includes(BILLS_TAGS.BREACH_OF_AGREEMENT)
        )
        state.bankSlips.isLoading = false
        state.bankSlips.content = bankSlips
        state.bankSlips.hasPendingNegotiated = !!negotiated
        state.bankSlips.daysToBreachOfAgreement = negotiated && negotiated.daysToBreachOfAgreement
      })
      .addCase(fetchBankSlips.rejected, state => {
        state.bankSlips.isLoading = false
        state.bankSlips.content = []
        state.bankSlips.error = true
        state.bankSlips.hasPendingNegotiated = false
        state.bankSlips.daysToBreachOfAgreement = null
      })
      .addCase(fetchBankSlips.pending, state => {
        state.bankSlips.isLoading = true
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.invoices.isLoading = false
        state.invoices.content.push(...action.payload.content)
        state.invoices.hasMore = action.payload.totalPages > action.payload.page
        state.invoices.page = action.payload.page
      })
      .addCase(fetchInvoices.rejected, state => {
        state.invoices.isLoading = false
        state.invoices.error = true
      })
      .addCase(fetchPaidInvoices.fulfilled, (state, action) => {
        state.paid.isLoading = false
        state.paid.content.push(...action.payload.content)
        state.paid.hasMore = action.payload.totalPages > action.payload.page
        state.paid.page = action.payload.page
      })
      .addCase(fetchPaidInvoices.rejected, state => {
        state.paid.isLoading = false
        state.paid.error = true
      })
  },
})

export default financialSlice.reducer
